import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

/**
 * now とdate（時間無視）を比較し
 * 同日なら時間を(HH:mm)を返し、それ以外は引数format形式を返す
 *
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
export const formatDateTimeShorten = (
  now = new Date(),
  date,
  format = 'YYYY/MM/DD'
) => {
  if (typeof date === 'undefined' || !date) return '';

  const today = dayjs(now).hour(0).minute(0).second(0);
  const target = dayjs(date);
  const targetDay = target.hour(0).minute(0).second(0);

  return targetDay.diff(today, 'day') === 0
    ? target.format('HH:mm')
    : target.format(format);
};

/**
 * サーバー時刻を返す。
 * 失敗した場合はクライアント時刻を返す
 *
 * @returns {Promise<Date>}
 */
export async function getNowDate() {
  const now = await axios
    .head(window.location.href)
    .then((res) => new Date(res?.headers?.date))
    .catch(() => {});

  return now || new Date();
}

export { dayjs };
